/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React, { useMemo, useRef } from "react";

import { bem } from "../../../shared/BEM";
import { IButtonComponentProps, Button } from "./ButtonComponent";

export interface ISubmitAction {
	/** HTTP method */
	method: string;

	/** URL path to submit data to */
	path: string;

	/** Data to serialize */
	data: any;

	/** Optional target window */
	target?: string;
}

/**
 * Component props
 */
export interface IButtonSubmitComponentProps extends IButtonComponentProps {
	onSubmit: () => ISubmitAction;
}

/**
 * Submit Button
 *
 * @param props Component props
 */
export function ButtonSubmit(props: IButtonSubmitComponentProps) {

	const formRef = useRef<HTMLFormElement>(null);
	const inputRef = useRef<HTMLInputElement>(null);

	const handleClick = useMemo(() => () => {

		const action = props.onSubmit();

		if (action) {

			formRef.current.setAttribute("method", action.method);
			formRef.current.setAttribute("action", action.path);

			if (action.target) {
				formRef.current.setAttribute("target", action.target);
			} else {
				formRef.current.removeAttribute("target");
			}

			inputRef.current.value = JSON.stringify(action.data);

			formRef.current.submit();

		}

		if (props.onClick) {
			props.onClick();
		}

	}, [ props.onSubmit, props.onClick ]);

	return <>
		<Button {...props} onClick={handleClick} />
		<form ref={formRef} className={bem("button", "submit-form").str}>
			<input type="hidden" name="data" ref={inputRef} />
		</form>
	</>

}
